import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sharedHelper } from '@/utils';

export const TaxService = {
    getAllTaxes,
    getTax,
    updateTax,
    createTax,
    updateTaxStatus
};

const MODULE = {
    TAX: 'taxes',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllTaxes(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }

    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.TAX}`, requestOptions)
  }

  export function getTax(id) {   
    return apiHelper(API_URL).get(`/${MODULE.TAX}/${id}`)
  }

  export function updateTax(data) {

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'name', data.name);
    sharedHelper.appendIfNotNull(formData, 'percentage', data.percentage);
    formData.append('_method', "put");
  
    return apiHelper(API_URL).post(`/${MODULE.TAX}/${data.id}`, formData)
  }

  export function createTax(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'name', data.name);
    sharedHelper.appendIfNotNull(formData, 'percentage', data.percentage);
  
    return apiHelper(API_URL).post(`/${MODULE.TAX}`, formData)
  }

  export function updateTaxStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.TAX}/${data.id}`, requestOptions)
    
  }